// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"Screens_pageContainer__3eTca","recipeContainer":"Screens_recipeContainer__n84Dg"};